import React from 'react'
import { Provider as ReduxProvider } from 'react-redux'
import { createRoot } from 'react-dom/client'

import AlertProvider from '@/context/AlertContext'
import StripeProvider from '@/context/StripeContext'

import store from '@/state'

import App from '@/App'

function Root() {
  return (
    <ReduxProvider store={store}>
      <AlertProvider>
        <StripeProvider>
          <App />
        </StripeProvider>
      </AlertProvider>
    </ReduxProvider>
  )
}

// Start the mocking conditionally and render after it's ready
async function startApp() {
  if (import.meta.env.DEV && import.meta.env.VITE_MOCK_API === 'msw') {
    // Dynamic import for ESM - wait for MSW to be ready
    const { worker } = await import('./mock-api/worker')
    await worker.start()
  }

  const rootTag = createRoot(document.getElementById('root') as HTMLElement)
  rootTag.render(<Root />)
}

startApp()
